import { Reducer } from "redux";

import { UpdateAgencyAccessListResponse } from "../models/api/Admin";
import { UpdateAgencyAccessActionTypes } from "../models/dispatchTypes/User";
import { UpdateAgencyAccessListActionDispatchTypes } from "../constants/User";

const initialState: UpdateAgencyAccessListResponse = {
  loading: false,
  response: null,
  error: null,
};

const PutAdminAccessListReducer: Reducer<
UpdateAgencyAccessListResponse,
UpdateAgencyAccessActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UpdateAgencyAccessListActionDispatchTypes.UPDATE_AGENCY_ACCESS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UpdateAgencyAccessListActionDispatchTypes.UPDATE_AGENCY_ACCESS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UpdateAgencyAccessListActionDispatchTypes.UPDATE_AGENCY_ACCESS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case UpdateAgencyAccessListActionDispatchTypes.UPDATE_AGENCY_ACCESS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PutAdminAccessListReducer;
